import React, { Component as C } from "react"
import PropTypes from "prop-types"
import keycode from "keycode"
import classNames from "classnames"
import BaseDialog from "../base-dialog/index.jsx"

import styles from "./dialog.less"
import scrollStyles from "@cirrus/legacy/app-components/app/styles/perfect-scrollbar.less"

export default class extends C {
  constructor(props) {
    super(props)
    this._tempClickTarget = null // because of 'bubbling' we use two events: onMouseDown(save target) and onClick(check, close and clear target)
    this._previousProps = {}
  }

  static defaultProps = {
    type: "base",
    hidden: false,
    insideContainerAction() {},
    outsideContainerAction() {},
  }

  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
    hidden: PropTypes.bool,
    top: PropTypes.number,
    autoFocus: PropTypes.bool,
    modalClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    mainClassName: PropTypes.string,
    insideContainerAction: PropTypes.func,
    outsideContainerAction: PropTypes.func,
    headerContent: PropTypes.any,
  }

  componentDidUpdate() {
    if (!this._previousProps.active && this.props.active) {
      this.manageHandlers(true)
    }
    if (this._previousProps.active && !this.props.active) {
      this.manageHandlers(false)
    }

    Object.assign(this._previousProps, this.props)
  }

  componentWillUnmount() {
    this.manageHandlers(false)
  }

  manageHandlers(add) {
    if (add) {
      document.body.classList.add(styles.modalOpen)
    } else {
      document.body.classList.remove(styles.modalOpen)
    }
  }

  getOverflowStyles() {
    return {
      overflowX: this.props.hasOuterScrollX ? "auto" : "hidden",
      overflowY: this.props.hasOuterScrollY ? "auto" : "hidden",
    }
  }

  handleModalMoseDown(e) {
    this._tempClickTarget = e.target
  }

  handleModalClick(e) {
    if (
      e.target == this.refs.modal &&
      this._tempClickTarget === e.target &&
      !this.props.closeButtonDisabled
    ) {
      this.props.onRequestClose(e)
    }
    this._tempClickTarget = null
  }

  render() {
    const { active, hidden } = this.props
    if (!active) return null

    const modalStyles = classNames(
      styles.modal,
      scrollStyles.scrollbar,
      this.props.modalClassName,
      hidden && styles.hidden,
    )
    const overlayStyles = classNames(styles.overlay, hidden && styles.hidden)

    return (
      <div>
        <div
          ref="modal"
          className={modalStyles}
          onClick={this.handleModalClick.bind(this)}
          onMouseDown={this.handleModalMoseDown.bind(this)}
          style={this.getOverflowStyles()}>
          <BaseDialog
            hideHeader={true}
            hideFooter={true}
            mainClassName={this.props.mainClassName}
            onRequestClose={this.props.onRequestClose}
            contentClassName={classNames(styles.content, this.props.contentClassName)}>
            <div>
              <div className={styles.header}>{this.props.header}</div>
              {this.props.children}
              <div className={styles.actions}>{this.props.actions}</div>
            </div>
          </BaseDialog>
        </div>

        <div className={overlayStyles} />
      </div>
    )
  }
}
